import script from "./PaySuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./PaySuccess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__